"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicSubmission = exports.getPublicSubmissions = exports.deleteSubmissionRelation = exports.postSubmissionRelation = exports.putSubmissionOrganization = exports.putSubmissionAccessibility = exports.deleteSubmissionPermission = exports.postSubmissionPermission = exports.putSubmissionAction = exports.postSubmission = exports.putSubmission = exports.getSubmission = exports.getSubmissions = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var submissionsAuthorizedPath = root_1.lmsAuthorized + '/submissions/';
var submissionsPublicPath = root_1.lmsPublic + '/submissions/';

var getSubmissions = function getSubmissions(authentication, queryParameters) {
  return common_1.get(authentication, submissionsAuthorizedPath, queryParameters);
};

exports.getSubmissions = getSubmissions;

var getSubmission = function getSubmission(authentication, id) {
  return common_1.get(authentication, submissionsAuthorizedPath + id);
};

exports.getSubmission = getSubmission;

var putSubmission = function putSubmission(authentication, submission) {
  return common_1.put(authentication, submissionsAuthorizedPath + submission.id, submission);
};

exports.putSubmission = putSubmission;

var postSubmission = function postSubmission(authentication, submission) {
  return common_1.post(authentication, submissionsAuthorizedPath, submission);
};

exports.postSubmission = postSubmission;

var putSubmissionAction = function putSubmissionAction(authentication, id, action, data) {
  return common_1.putSub(authentication, submissionsAuthorizedPath, id, action, data);
};

exports.putSubmissionAction = putSubmissionAction;

var postSubmissionPermission = function postSubmissionPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, submissionsAuthorizedPath, id, permission);
};

exports.postSubmissionPermission = postSubmissionPermission;

var deleteSubmissionPermission = function deleteSubmissionPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, submissionsAuthorizedPath, id, permissionId);
};

exports.deleteSubmissionPermission = deleteSubmissionPermission;

var putSubmissionAccessibility = function putSubmissionAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, submissionsAuthorizedPath, id, accessibility);
};

exports.putSubmissionAccessibility = putSubmissionAccessibility;

var putSubmissionOrganization = function putSubmissionOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, submissionsAuthorizedPath, id, organizationId);
};

exports.putSubmissionOrganization = putSubmissionOrganization;

var postSubmissionRelation = function postSubmissionRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, submissionsAuthorizedPath, id, relation);
};

exports.postSubmissionRelation = postSubmissionRelation;

var deleteSubmissionRelation = function deleteSubmissionRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, submissionsAuthorizedPath, id, relationId);
};

exports.deleteSubmissionRelation = deleteSubmissionRelation;

var getPublicSubmissions = function getPublicSubmissions(authentication, queryParameters) {
  return common_1.get(authentication, submissionsPublicPath, queryParameters);
};

exports.getPublicSubmissions = getPublicSubmissions;

var getPublicSubmission = function getPublicSubmission(authentication, id) {
  return common_1.get(authentication, submissionsPublicPath + id);
};

exports.getPublicSubmission = getPublicSubmission;